import CloseIcon from '@mui/icons-material/Close'
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material'
import { FC } from 'react'
import { APP_COMMIT_HASH, APP_VERSION } from '../../utils/appVersion'

const BUILD_INFO = [
  { label: 'Version', value: `v${APP_VERSION}`, testId: 'app-version-value' },
  { label: 'Git hash', value: APP_COMMIT_HASH, testId: 'app-githash-value' }
]

type AppVersionDialogProps = {
  open: boolean
  onClose: () => void
}

/**
 * Dialog showing the running build's version and git commit hash.
 *
 * This is a controlled component; the caller owns the open state (see UserProfileCard).
 */
export const AppVersionDialog: FC<AppVersionDialogProps> = ({ open, onClose }) => (
  <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth data-testid="app-version-dialog" aria-labelledby="app-version-dialog-title">
    <DialogTitle id="app-version-dialog-title" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      About
      <IconButton aria-label="Close" data-testid="app-version-close" size="small" onClick={onClose}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </DialogTitle>

    <DialogContent>
      <Box
        component="dl"
        sx={{ display: 'grid', gridTemplateColumns: 'auto 1fr', columnGap: 'var(--spacing-m)', rowGap: 'var(--spacing-2xs)', margin: 0 }}
      >
        {BUILD_INFO.map(({ label, value, testId }) => (
          <Box key={label} sx={{ display: 'contents' }}>
            <Typography component="dt" sx={{ fontSize: 'var(--size-xs)', color: 'var(--text-secondary)' }}>
              {label}
            </Typography>
            <Typography component="dd" data-testid={testId} sx={{ fontSize: 'var(--size-xs)', margin: 0 }}>
              {value}
            </Typography>
          </Box>
        ))}
      </Box>
    </DialogContent>
  </Dialog>
)
